import { Component, Input, ChangeDetectionStrategy } from '@angular/core';

import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'va-nav-item',
  templateUrl: './nav-item.component.html',
  styleUrls: ['./nav-item.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [CommonModule, MatButtonModule, MatIconModule, RouterModule],
})
export class VaNavItemComponent {
  @Input() label: string;
  @Input() icon: string;
  @Input() url: string;
  @Input() queryParams: any;
  @Input() selected: boolean;
  @Input() isSvg = false;
  @Input() activeExactRoute = false;
}
